import React from 'react';
import { Form, Input, Modal, Radio } from 'antd';
import { PostStatus } from '../../_services/service'
export function BatchUpdatePostsStatusForm(props) {
    const { visible, onCancel, onSubmit, loading, records } = props;
    const [form] = Form.useForm();
    const handleSubmit = () => {
        form.validateFields().then(async (values) => {
            await onSubmit(Object.assign(Object.assign({}, values), { ids: records.map((item) => item.id) }));
        });
    };
    // 重置表单
    React.useEffect(() => {
        if (!visible) {
            return;
        }
        form.resetFields();
    }, [visible, form]);
    return (<Modal 
    // @see https://ant.design/components/form-cn/#FAQ
    forceRender title='Confirm approve roster' open={visible} onCancel={onCancel} onOk={handleSubmit} okButtonProps={{ loading }}>
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
        <span>Are you sure you want to approve 24 rosters?</span>
        {/* <Form.Item name='remark' label='remark' rules={[
            {
                required: true,
                message: 'remark is required',
            },
        ]}>
          <Input.TextArea placeholder='填写备注'></Input.TextArea>
        </Form.Item> */}
        {/* <Form.Item name='status' label='status' required initialValue={PostStatus.Draft}>
          <Radio.Group>
            <Radio value={PostStatus.Draft}>draft 0</Radio>
            <Radio value={PostStatus.Published}>published 1</Radio>
          </Radio.Group>
        </Form.Item> */}
      </Form>
    </Modal>);
}
